import React, { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";
// import { FaSliders } from "react-icons/fa6";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useLoader, useModal } from "../../context/LoaderContext";
import { axiosInstance } from "../../config/https";
import User from "../../assets/images/james-img.png";

export default function InviteFreelancerComp() {
  const { id } = useParams();
  const { startLoader, stopLoader } = useLoader();
  const [allFreelancers, setAllFreelancers] = useState([]);
  const [filterFreelancers, setFilterFreelancers] = useState([]);
  const { openModal } = useModal();

  useEffect(() => {
    const getFreelancers = () => {
      startLoader();
      axiosInstance
        .get(`/api/seller/sellersinfo/?invite=${id}`)
        .then((resp) => {
          stopLoader();
          const Data = resp.data;
          if (resp.status === 200 || resp.status === 201) {
            setAllFreelancers(Data);
            setFilterFreelancers(Data);
          } else {
            toast.warning(Data.msg);
          }
        })
        .catch(() => {
          stopLoader();
        });
    };
    getFreelancers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const inviteFreelancer = (freelancerId) => {
    startLoader();
    axiosInstance
      .post(`/api/send-notification/${freelancerId}/`, { job_id: id })
      .then((resp) => {
        const Data = resp.data;
        if (resp.status === 200 || resp.status === 201) {
          setFilterFreelancers(
            filterFreelancers.filter((e) => e.user.id !== freelancerId)
          );
          setAllFreelancers(
            allFreelancers.filter((e) => e.user.id !== freelancerId)
          );
          stopLoader();
          openModal(
            "invite", //gif url
            "Unlock Potential!", //title
            "Elevate your project – invite skilled freelancers to join your team and turn ideas into reality!." //subtitle
          );
          toast.success(Data.content);
        } else {
          toast.warning(Data.msg);
        }
      })
      .catch(() => {
        stopLoader();
      });
  };

  const handleFilterChange = (event) => {
    const value = event.target.value.toLowerCase();
    const filteredData = allFreelancers.filter((item) =>
      item?.user?.name.toLowerCase().includes(value)
    );
    setFilterFreelancers(filteredData);
  };

  return (
    <section className="invite-freelancers pc-p-3">
      <div className="container-fluid px-5">
        <div className="myjob-table">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <form action="" className="search-form">
                <div className="form-group mb-0">
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Search Freelancer..."
                    onChange={handleFilterChange}
                  />
                  <button>
                    <FaSearch />
                  </button>
                </div>
              </form>
            </div>
            {/* <div className="col-lg-3">
              <Link to="#" className="primary-btn black-bg">
                {" "}
                <FaSliders /> Filters{" "}
              </Link>
            </div> */}
            {/* <div className="col-lg-1">
              <div className="primary-heading color-dark text-right">
                <p className="mb-0">Scope :</p>
              </div>
            </div>
            <div className="col-lg-2">
              <div className="search-form">
                <select className="form-control">
                  <option value="Best Match">Best Match</option>
                </select>
              </div>
            </div> */}
          </div>
        </div>
        {filterFreelancers.map((e, i) => (
          <div className="invite-box" key={i}>
            <div className="row">
              <div className="col-lg-2">
                <div className="invite-box-img">
                  <p>Best Match</p>
                  <figure>
                    <img
                      src={e?.profile_picture?.profile_picture || User}
                      alt="James"
                    />
                  </figure>
                </div>
              </div>
              <div className="col-lg-10">
                <div className="invite-box-content">
                  <div className="row">
                    <div className="col-lg-8">
                      <div className="invite-box-content-head">
                        <div className="primary-heading color-dark">
                          <h4>{e?.user?.name}</h4>
                          <span className="tag">Personal Website</span>
                          <span className="country">{e?.personal_website}</span>
                          {/* <ul>
                            <li>$10</li>
                            <li>$22 earned</li>
                          </ul> */}
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <ul className="d-flex justify-content-end">
                        <li className="mr-0">
                          <Link
                            to={"#"}
                            className="primary-btn primary-bg mr-3"
                          >
                            Message
                          </Link>
                        </li>
                        <li>
                          <Link
                            to={"#"}
                            onClick={() => inviteFreelancer(e?.user?.id)}
                            className="primary-btn secondary-bg"
                          >
                            Invite To Job
                          </Link>
                        </li>
                      </ul>
                    </div>
                    <div className="col-12">
                      <div className="primary-heading color-dark">
                        <p>{e?.description}</p>
                        <div className="tags">
                          <ul className="tags">
                            {e?.skills?.map((e, i) => (
                              <li key={i}>{e.name}</li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
